import i18n from 'services/base/i18n';

export default {
  // Text on a button allowing the user to show their password
  show: () => i18n.pgettext('Components|Password Input', 'SHOW'),

  // Text on a button allowing the user to hide their password
  hide: () => i18n.pgettext('Components|Password Input', 'HIDE'),
};
